import React, { useCallback, useEffect, useState } from "react";
import ClientVideoView from "components/videoView/ClientVideoView";
import { useSelector, useDispatch } from "react-redux";
import { pauseConsumer, resumeConsumer, selectConsumers } from "store/consumerSlice";
import { selectPeers } from "store/peerSlice";
import { MyConsumer, PeerInfo } from "types/clientTypes";
// import { useHostPeer } from "hooks/useHostPeer";
import { AppData } from "types/commonTypes";
import { selectCurrentHostSocketId } from "store/docSharingSlice";
import { LayoutType, selectLayoutType } from "store/roomInfoSlice";
// import { useFilteredPeers } from "hooks/useFilteredPeers";

interface IProps {
  localAppData?: AppData;
  includeHost?: boolean;
  includeDocHost?: boolean;
  maxDisplayPeers?: number;
}

const PeerVideoList = (props: IProps) => {
  const { localAppData, includeHost, includeDocHost, maxDisplayPeers } = props;
  const [peersToShow, setPeersToShow] = useState<PeerInfo[]>([]);
  const consumers = useSelector(selectConsumers);
  const peers = useSelector(selectPeers);
  const [hostPeer, setHostPeer] = useState<PeerInfo | undefined>(peers?.find(item => item.isHost));
  const docSharingHostSocketId = useSelector(selectCurrentHostSocketId);
  const layoutType = useSelector(selectLayoutType);
  // const hostPeer = useHostPeer();
  const dispatch = useDispatch();
  // const { filteredPeers, excludeCnt } = useFilteredPeers({ localSocketId: localAppData?.socketId, includeHost, includeDocHost });

  useEffect(() => {
    console.log("***** PeerVideoList - 호출~~~~~~~");
  });

  const findConsumer = useCallback(
    (socketId: string) => {
      const findConsumer = consumers.filter(
        (myconsumer: MyConsumer) => myconsumer.consumer.appData.socketId === socketId && myconsumer.consumer.kind === "video",
      );

      if (findConsumer.length > 0) return findConsumer[0];
      else return undefined;
    },
    [consumers],
  );

  useEffect(() => {
    const findPeer = peers.find(item => item.isHost);
    setHostPeer(findPeer);
  }, [peers]);

  useEffect(() => {
    console.log("***** PeerVideoList peers *****", peers);
    // console.log("***** PeerVideoList consumers *****", consumers);

    let excludeCnt = 0; // 사회자, 로컬, 문서공유 호스트로 제외된 peer 수

    // 표시할 peer 만 남긴다.
    const filteredPeers = peers.filter((peer: PeerInfo) => {
      if (!includeHost && peer.socketId === hostPeer?.socketId) {
        console.log("PeerVideoList - 사회자 제외");
        excludeCnt++;
        return false; // 사회자 제외
      } else if (peer.socketId === localAppData?.socketId) {
        console.log("PeerVideoList - 로컬 제외");
        excludeCnt++;
        return false; // 로컬 제외
      } else if (!includeDocHost && peer.socketId === docSharingHostSocketId) {
        console.log("PeerVideoList - 문서공유 호스트는 제외");
        excludeCnt++;
        return false; // 문서공유 호스트 제외
      }
      return true;
    });

    if (maxDisplayPeers && filteredPeers && layoutType === LayoutType.Split) {
      console.log("## PeerVideoList - maxDisplayPeers, filteredPeers.length excludeCnt", maxDisplayPeers, filteredPeers.length, excludeCnt);

      // 사회자, 로컬, 문서공유 호스트를 제외하고 최대 표시수를 구한다.
      const limitPeerCnt = Math.min(peers.length, maxDisplayPeers);
      console.log(`표시되는 limitPeerCnt: ${limitPeerCnt}`);

      const showPeers: PeerInfo[] = [];

      filteredPeers.forEach((peer: PeerInfo) => {
        if (showPeers.length >= limitPeerCnt - excludeCnt) {
          console.log("표시 안 되게 설정할 peer", peer.userInfo.username);
          dispatch(pauseConsumer({ socketId: peer.socketId, kind: "video", source: "webcam" }));
        } else {
          // console.log("표시 되게 설정할 peer", peer.userInfo.username);
          dispatch(resumeConsumer({ socketId: peer.socketId, kind: "video", source: "webcam" }));
          showPeers.push(peer);
        }
      });

      console.log("showPeers.length ==>", showPeers.length);
      setPeersToShow(showPeers);
    } else if (filteredPeers) {
      setPeersToShow(filteredPeers);
    }
  }, [dispatch, peers, maxDisplayPeers, includeHost, hostPeer, localAppData?.socketId, includeDocHost, docSharingHostSocketId, layoutType]);

  // useEffect(() => {
  //   console.log("************************************** 랜더링 원인 peers");
  // }, [peers]);

  if (peersToShow.length === 0) {
    return <></>;
  }

  return (
    <>
      {peersToShow.map((peer: PeerInfo) => {
        const myConsumer: MyConsumer = findConsumer(peer.socketId) as unknown as MyConsumer;

        return (
          <ClientVideoView
            key={peer.socketId}
            isRemote
            isHost={peer.socketId === hostPeer?.socketId}
            socketId={peer.socketId}
            stream={myConsumer && peer.isCamEnable ? myConsumer.stream : undefined}
            consumer={myConsumer && peer.isCamEnable ? myConsumer.consumer : undefined}
            userInfo={peer.userInfo}
          />
        );
      })}
    </>
  );
};

PeerVideoList.defaultProps = {
  incluseHost: false,
  includeDocHost: false,
};

export default React.memo(PeerVideoList);
